import React from "react";
import "./ProblemStatus.scss";

function ProblemStatus({ status }) {
  return (
    <div
      className="problemStatus"
      style={
        status === "Open"
          ? { backgroundColor: "#FCC94A", color: "#1d3943", cursor: "pointer" }
          : { backgroundColor: "#1da193", color: "#FBFBFB", cursor: "pointer" }
      }
    >
      {status === "Open" ? "Në pritje" : "Zgjidhur"}
    </div>
  );
}

export default ProblemStatus;
